import React from 'react';
import { useNavigate } from "react-router-dom";
import { Flex } from "reflexbox";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import PageHeader from "../gamePlayComponents/PageHeader";
import { courses, experiences, CITIES } from "../courseContent/courseObjects";
import * as route from "../helpers/routes";
import { isProd } from "../helpers/misc";

const LeaderboardCourseSelector = () => {
  const navigate = useNavigate();

  // Build mapping: city -> experiences -> course keys
  const cityKeys = Object.values(CITIES || {});
  const today = new Date();

  const getCoursesForExperience = (experienceId) =>
    Object.entries(courses || {}).filter(
      ([, course]) => course.experienceId === experienceId
    );

  return (
    <>
      <PageHeader title="Leaderboards" goBack />
      <Card style={{ marginTop: '8px' }}>
        <CardContent>
          <Typography variant="body1" gutterBottom>
            Select a course to view its full leaderboard.
          </Typography>

          {cityKeys.map((cityName) => {
            const experienceEntries = Object.entries(experiences || {}).filter(
              ([, exp]) => {
                // Hide the QA-only test course in production, matching CourseSelectorScreen
                if (isProd && exp.id === 'testCourse') return false;

                if (exp.city !== cityName) return false;

                const window = exp.availabilityWindow;
                if (!window) return true;

                const start = window.start ? new Date(window.start) : null;
                const end = window.end ? new Date(window.end) : null;

                if (start && today < start) return false;
                if (end && today > end) return false;

                return true;
              }
            );

            if (!experienceEntries.length) return null;

            return (
              <div key={cityName} style={{ marginTop: '16px' }}>
                <Typography variant="subtitle1" color="primary" gutterBottom>
                  {cityName}
                </Typography>

                {experienceEntries.map(([expKey, exp]) => {
                  const courseEntries =
                    exp.variantKeys?.length
                      ? exp.variantKeys
                          .map((courseKey) => [courseKey, courses[courseKey]])
                          .filter(([, course]) => !!course)
                      : getCoursesForExperience(expKey);

                  if (!courseEntries.length) return null;
                  const showExperienceTitle = courseEntries.length > 1;

                  return (
                    <div key={expKey} style={{ marginBottom: '12px' }}>
                      {showExperienceTitle && (
                        <Typography variant="subtitle2" gutterBottom>
                          {exp.name}
                        </Typography>
                      )}
                      <Flex
                        style={{
                          flexDirection: 'column',
                          gap: '8px',
                          marginTop: '4px',
                        }}
                      >
                        {courseEntries.map(([courseKey, course]) => (
                          <Button
                            key={courseKey}
                            variant="outlined"
                            color="primary"
                            style={{
                              width: '100%',
                              justifyContent: 'space-between',
                            }}
                            onClick={() =>
                              navigate(`${route.LEADERBOARD}/${courseKey}`)
                            }
                          >
                            <span>{course.friendlyCourseName}</span>
                          </Button>
                        ))}
                      </Flex>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </CardContent>
      </Card>
    </>
  );
};

export default LeaderboardCourseSelector;

